<template>
  <div class="sb_switch-mode">
    <Label class="sb_switch-mode_label" :line="false">
      <template #title>Bestel jouw ontwerp op</template>
      <template #input>
        <div class="sb_switch-mode_label_wrapper" v-if="typeOptions">
          <button
            class="sb_switch-mode_button"
            :class="{ s_active: option.name === design.type }"
            v-for="option in typeOptions"
            :key="`design-mode-option-${option.name}`"
            @click="setMode(option.name)"
          >
            <SvgIcon
              class="sb_switch-mode_button_icon"
              :class="`v_${option.title.toLowerCase().replace(/ /g, '-')}`"
              :icon="option.title.toLowerCase().replace(/ /g, '-')"
            />
            <span>{{ option.title }}</span>
          </button>
        </div>
      </template>
    </Label>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

export default {
  name: 'SwitchMode',
  data: () => ({}),
  computed: {
    ...mapState('design', ['design']),
    ...mapState('types', ['types']),
    ...mapState('canvas', ['manager']),
    typeOptions() {
      return this.types.map((item) => {
        item.title = {
          BEHANG: 'Behang',
          CANVAS: 'Foto Frame',
        }[item.name];
        return item;
      });
    },
  },
  created() {
    window.fotowandDesigner.setType = (type) => {
      this.setMode(type);
    };
  },
  methods: {
    ...mapMutations('design', ['setDesignDimensions', 'setType']),
    ...mapActions('design', ['calculatePrice']),
    async setMode(mode) {
      this.$emit('update:mode', mode);
      await this.manager.setType(mode);
      this.setType(mode);
      this.calculatePrice();
    },
  },
};
</script>

<style lang="scss">
#sb_fotowand-designer {
  .sb_switch-mode {
    display: flex;
    width: 100%;
    height: 2.8rem;
    order: -1;
    @include media('>=small') {
      width: 55%;
      order: 0;
      flex-grow: 1;
      justify-content: flex-end;
      padding-left: 0.3rem;
    }
    @include media('>=medium-portrait') {
      width: auto;
      padding-left: 0;
      flex-grow: 1;
    }
    @include media('>=medium') {
      width: auto;
      height: 3.4rem;
    }
    &_label {
      width: 100% !important;
      @include media('>=medium-portrait') {
        width: auto !important;
      }
    }
    &_label_wrapper {
      display: flex;
      height: 100%;
      background: $brand-white;
      padding: 0.2rem 0.2rem;
      align-items: center;
      border-radius: $default-radius;
      border: 3px solid $brand-lightest-gray;
      @include media('>=medium-portrait') {
        padding: 0.3rem 0.3rem;
      }
      @include media('>=medium') {
        padding: 0.45rem 0.4rem;
      }
    }
    &_button {
      border: 0;
      width: 100%;
      height: 100%;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      font-size: 0.9rem;
      font-weight: 500;
      padding: 0 0.4rem;
      transition: color 0.4s, background 0.4s;
      width: 100%;
      position: relative;
      &:hover {
        cursor: pointer;
      }
      span {
        transform: translateY(01px);
        display: inline-flex;
        white-space: nowrap;
        justify-content: center;
        align-items: center;
        letter-spacing: 0.6px;
        @include media('>=medium-portrait') {
          position: absolute;
          transition: font-weight 0.4s;
          right: 0.8rem;
        }
        @include media('>=medium-portrait') {
          right: 1rem;
        }
      }
      &_icon {
        font-size: 1rem;
        margin-right: 0.6rem;
        &.v_behang {
          font-size: 1.2rem;
          transform: translateY(-0.1rem);
        }
        @include media('>=medium-portrait') {
          position: absolute;
          left: 0.8rem;
          &.v_behang {
            transform: translateY(-0.15rem);
          }
        }
        @include media('>=medium') {
          left: 1rem;
        }
      }
      &:last-of-type {
        margin-left: 0.2rem;
        width: 100%;
      }
      &.s_active {
        color: $brand-white;
        background: $brand-primary;
      }
      &:hover {
        color: $brand-white;
        background: $brand-primary-light;
      }
      &.s_active {
        color: $brand-white;
        background: $brand-primary;
        @include media('>=medium-portrait') {
          font-weight: 700;
        }
      }
      @include media('>=medium-portrait') {
        width: 7rem;
        padding: 0 0.8rem;
        &:last-of-type {
          width: 8.2rem;
        }
      }
      @include media('>=medium') {
        font-size: 1rem;
        width: 7.5rem;
        padding: 0 1rem;
        &:last-of-type {
          width: 9.3rem;
        }
      }
    }
  }
}
</style>
